// @flow

import { type Details } from './types';

export function getBillingDescriptor(details: Details): string {
  return details['billing_descriptor'];
}
